var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-wrapper",class:{
        'message-wrapper--has-avatar': _vm.avatarUrl,
        'message-wrapper--has-left-padding': _vm.hasLeftPadding,
        'message-wrapper--has-right-padding': _vm.hasRightPadding,
    }},[_c('div',{staticClass:"message"},[_vm._t("default")],2),(_vm.avatarUrl)?_c('Avatar',{staticClass:"message-wrapper-avatar",attrs:{"image-url":_vm.avatarUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }